import React, { Component } from "react"

/* Widgets */
import { SelectModal } from "./widgets"

/* REST API */
import { parent } from '../../../api/Brand'
import { list } from "../../../api/Category"
import { view, update, categorycreate, categorydelete, removeImage, uploadGallery, removeGallery, brandcreate, branddelete } from '../../../api/Product'

/* Sweet alert */
import Swal from "sweetalert2"

/* Helpers */
import { utils, withRouter } from '../../../helpers'

/* Constants */
import { env } from "../../../constants"

/*
    Page Edit Product
*/
class EditProduct extends Component {

    constructor(props) {
        super(props)

        const { params } = this.props

        this.state = {
            id: params.id,
            parents: [],
            name: "",
            article: "",
            slug: "",

            brands: [],
            searchList: [],
            productCategories: [],
            productBrands: [],

            price: "",
            salePrice: "",
            description: "",

            image: null,
            gallery: [],

            volume: "",
            weight: "",

            place: "",
            minquantity: '',

            code: '',
            connectionType: "category",
            viewProduct: '',
            unit: '',

            pricePercent: '',
            salePricePercent: '',
        }
    }

    componentDidMount = () => {
        this.product()
        this.load()
    }

    /* Load Categories */
    load = () => {
        parent().then(response => {
            if (response.status === 200) {
                this.setState({ brands: response.data.brands })
            }
        })
    }

    /* Get category item */
    category = (data) => {
        list(data).then(response => {
            if (response.status === 200) {
                this.setState({
                    searchList: response.data.categories,
                })
            }
        })
    }

    /* Load Products */
    product = () => {
        const { id } = this.state

        view({ productID: id }).then(response => {
            if (response.status === 200) {

                const responseData = response.data

                const data = responseData.product
                const categories = responseData.categories
                const productBrands = responseData.brands

                this.setState({
                    name: data.name,
                    article: data.article,
                    slug: data.slug,
                    categoryID: data.categoryID,
                    price: data.price,
                    salePrice: data.salePrice,
                    description: data.description ? data.description : "",
                    picture: data.image ? 'https://back.tgc-group.kz/products/' + data.image : null,
                    gallery: data.galleries ? data.galleries : [],
                    volume: data.volume,
                    weight: data.weight,
                    place: data.place ? data.place : "",
                    minquantity: data.minquantity ?? '',
                    code: data.code,
                    connectionType: data.connectionType ? data.connectionType : "category",
                    viewProduct: data.view,
                    unit: data.unit,
                    pricePercent: data.pricePercent,
                    salePricePercent: data.salePricePercent,
                    productCategories: categories,
                    productBrands: productBrands
                })
            }
        })
    }

    /* Draw Top */
    _top = () => {

        return (
            <div className="content-top">

                <div className="content-name">
                    <img src="/pictures/product.png" alt="Product" />
                    <p>Редактировать продукт</p>
                </div>

            </div>
        )
    }



    /* CREATE PRODUCT */
    create = () => {

        const {
            id, name, article, slug, price, salePrice, description,
            volume, weight, place, code, connectionType, viewProduct, unit, pricePercent, salePricePercent, image, picture, minquantity
        } = this.state

        const { navigate } = this.props

        if (name === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите название', showConfirmButton: false, timer: 1500 })
            return
        }

        if (article === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите артикул', showConfirmButton: false, timer: 1500 })
            return
        }

        if (slug === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите Key (URL)', showConfirmButton: false, timer: 1500 })
            return
        }

        if (price) {
            if (!utils.isNumeric(price)) {
                Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Неправильная цена', showConfirmButton: false, timer: 1500 })
                return
            }
        }

        if (code === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите код', showConfirmButton: false, timer: 1500 })
            return
        }

        if (viewProduct === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите вид', showConfirmButton: false, timer: 1500 })
            return
        }
        if (unit === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите единицу измерения', showConfirmButton: false, timer: 1500 })
            return
        }

        if (pricePercent === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите комиссию (роз)', showConfirmButton: false, timer: 1500 })
            return
        }
        if (salePricePercent === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите комиссию (опт)', showConfirmButton: false, timer: 1500 })
            return
        }

        if (salePrice) {
            if (!utils.isNumeric(salePrice)) {
                Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Неправильная оптовая цена', showConfirmButton: false, timer: 1500 })
                return
            }
        }

        // const data = {
        //     productID: id, name, article, slug, categoryID, price, comment: description, volume, weight, code, view: viewProduct, unit, pricePercent, salePricePercent
        // }

        const obj = new FormData

        obj.append('productID', id)
        obj.append('name', name)
        obj.append('article', article)
        obj.append('slug', slug)
        obj.append('price', price)
        obj.append('comment', description)
        obj.append('volume', volume)
        obj.append('weight', weight)
        obj.append('place', place)
        obj.append('minquantity', minquantity)
        obj.append('code', code)
        obj.append('connectionType', connectionType)
        obj.append('view', viewProduct)
        obj.append('unit', unit)
        obj.append('pricePercent', pricePercent)
        obj.append('salePricePercent', salePricePercent)

        if (image) {
            obj.append('image', image)
        } else if (picture === null) {
            obj.append('image', null)
        }


        update(obj).then(response => {
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Успешно сохранен',
                    showConfirmButton: false,
                    timer: 1500,
                    didClose: () => {
                        navigate('/product')
                    }
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Что-то пошло не так! Попробуйте позднее',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'Что-то пошло не так! Попробуйте позднее',
                showConfirmButton: false,
                timer: 1500
            })
        })

    }



    /* Set Name */
    setName = event => {
        this.setState({ name: event.target.value })
        const slug = utils.translit(event.target.value)
        this.setState({ slug })
    }


    /* Upload Image */
    upload = event => {
        let file = event.target.files[0]

        if (file) {
            this.setState({ image: file, picture: URL.createObjectURL(file) })
        }
    }

    /* Remove Image */
    removeImage = () => {
        const { id } = this.state

        removeImage({ productID: id }).then(response => {
            if (response.status === 200) {
                this.setState({ image: null })
            }
        })
    }

    /* Upload to Gallery */
    uploadGallery = event => {

        const { id, gallery } = this.state

        for (let file of event.target.files) {

            const data = new FormData()
            data.append('productID', id)
            data.append('image', file)

            uploadGallery(data).then(response => {
                if (response.status === 200) {
                    gallery.push({ id: response.data.id, image: response.data.image })
                    this.setState({ gallery })
                }
            })
        }
    }


    /* Remove from gallery */
    removeGallery = (item, index) => {
        removeGallery({ imageID: item.id }).then(response => {
            if (response.status === 200) {
                const { gallery } = this.state
                gallery.splice(index, 1)
                this.setState({ gallery })
            }
        })
    }

    /* Add category to selected list */
    add = (item) => {

        const { id, productCategories, productBrands, connectionType } = this.state

        const isCategory = connectionType === "category"

        const addFunction = isCategory ? categorycreate : brandcreate
        const data = isCategory ? { productID: id, categoryID: item.id } : { productID: id, brandID: item.id }

        addFunction(data).then(response => {
            if (response.status === 200) {

                const created = response.data.created

                const list = isCategory ? productCategories : productBrands
                const i = list.findIndex(e => e.id === item.id)
                if (i === -1) {
                    if (isCategory) {
                        this.setState({ productCategories: [{ pcID: created.id, ...item }, ...productCategories] })
                    } else {
                        this.setState({ productBrands: [{ pbID: created.id, ...item }, ...productBrands] })
                    }
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Успешно добавлено',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Что-то пошло не так! Попробуйте позднее',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        })

    }

    remove = (item) => {

        const { connectionType } = this.state

        const isCategory = connectionType === "category"

        const deleteFunction = isCategory ? categorydelete : branddelete
        const data = isCategory ? { pcID: item.pcID } : { pbID: item.pbID }

        console.log(data)

        deleteFunction(data).then(response => {
            if (response.status === 200) {

                const { productCategories, productBrands } = this.state

                const list = isCategory ? productCategories : productBrands

                const tempList = list.filter(e => e.id !== item.id)

                if (isCategory) {
                    this.setState({ productCategories: tempList })
                } else {
                    this.setState({ productBrands: tempList })
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Успешно удалено',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Что-то пошло не так! Попробуйте позднее',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        })
    }

    setConnectionType = (type) => {

        const { connectionType } = this.state

        if (type !== connectionType) {
            this.setState({ connectionType: type })
        }

        return
    }

    render = () => {

        const { name, article, slug, connectionType, price, salePrice, description, viewProduct, picture, volume, weight, place, code, unit, brands, searchList, productCategories, productBrands, pricePercent, salePricePercent, gallery, minquantity } = this.state

        return (
            <div className="content">

                {this._top()}

                <div className="content-box">
                    <div className="content-form-box">

                        <div className="content-form-half">
                            <p>Название продукта</p>
                            <input type="text" value={name} onChange={event => this.setName(event)} placeholder="Введите название" />

                            <p>Key (URL)</p>
                            <input type="text" value={slug} onChange={event => this.setState({ slug: event.target.value })} placeholder="Введите Key" />

                            <p>Артикул</p>
                            <input type="text" value={article} onChange={event => this.setState({ article: event.target.value })} placeholder="Введите артикул" />

                            <p>Код</p>
                            <input type="text" value={code} onChange={event => this.setState({ code: event.target.value })} placeholder="Введите код" />

                            <p>Добавить</p>
                            <div className="connection-types">
                                <div className={`type ${connectionType === 'category' ? "active" : ""}`} onClick={() => this.setConnectionType('category')}><p>Категория</p></div>
                                <div className={`type ${connectionType === 'brand' ? "active" : ""}`} onClick={() => this.setConnectionType('brand')}><p>Бренд</p></div>
                            </div>

                            <p>{connectionType === "category" ? "Категория" : "Бренд"}</p>
                            <SelectModal
                                connectionType={connectionType}
                                selected={connectionType === "category" ? productCategories : productBrands}
                                list={connectionType === "category" ? searchList : brands ? brands : []}
                                brands={brands}
                                search={data => this.category(data)}
                                add={item => this.add(item)}
                                remove={id => this.remove(id)}
                                target={connectionType === "category" ? "категорию" : "бренд"}
                            />

                            <p>Цена</p>
                            <input type="text" value={price} onChange={event => this.setState({ price: event.target.value })} placeholder="Введите цену (₸)" />

                            <p>Оптовая цена</p>
                            <input type="text" value={salePrice} onChange={event => this.setState({ salePrice: event.target.value })} placeholder="Введите скидочную цену (₸)" />
                            <p>Основная картинка</p>

                            <div className="content-gallery-box">
                                {/* `${env.mediapoint}products/${image}` */}
                                {picture
                                    ?
                                    <div className="content-gallery-item">
                                        <img src={picture} alt="Gallery" />
                                        <div onClick={() => this.setState({ picture: null, image: null })} className="content-gallery-remove">
                                            <img alt="Minus" src="/pictures/minus.png" />
                                        </div>
                                    </div>
                                    :
                                    <label className="content-gallery-file">
                                        <input multiple={true} onChange={event => this.upload(event)} type="file" name="file" accept="image/png, image/jpeg" />
                                        <div className="content-gallery-button">
                                            <img src="/pictures/image-upload.png" alt="Add" />
                                        </div>
                                    </label>
                                }

                            </div>

                            <p>Галерея</p>

                            <div className="content-gallery-box">

                                <label className="content-gallery-file">
                                    <input multiple={true} onChange={event => this.uploadGallery(event)} type="file" name="file" accept="image/png, image/jpeg" />
                                    <div className="content-gallery-button">
                                        <img src="/pictures/image.png" alt="Add" />
                                    </div>
                                </label>

                                {gallery.map((item, index) =>
                                    <div key={`${index}`} className="content-gallery-item">
                                        <img src={'https://back.tgc-group.kz/products/' + item.image} alt="Gallery" />
                                        <div onClick={() => this.removeGallery(item, index)} className="content-gallery-remove">
                                            <img alt="Minus" src="/pictures/minus.png" />
                                        </div>
                                    </div>
                                )}

                            </div>

                        </div>

                        <div className="content-form-half">
                            <p>Вид</p>
                            <input type="text" value={viewProduct} onChange={event => this.setState({ viewProduct: event.target.value })} placeholder="Введите вид" />

                            <p>Единица измерения</p>
                            <input type="text" value={unit} onChange={event => this.setState({ unit: event.target.value })} placeholder="Введите ед.из" />

                            <p>Объем</p>
                            <input type="text" value={volume} onChange={event => this.setState({ volume: event.target.value })} placeholder="Введите объем" />

                            <p>Вес</p>
                            <input type="text" value={weight} onChange={event => this.setState({ weight: event.target.value })} placeholder="Введите вес" />

                            <p>Место</p>
                            <input type="text" value={place} onChange={event => this.setState({ place: event.target.value })} placeholder="Введите место" />

                            <p>Мин.порог</p>
                            <input type="number" value={minquantity} onChange={event => this.setState({ minquantity: event.target.value })} placeholder="Минимальное количество" />

                            <p>Комиссия (роз)</p>
                            <input type="text" value={pricePercent} onChange={event => this.setState({ pricePercent: event.target.value })} placeholder="Введите комиссию (роз)" />

                            <p>Комиссия (опт)</p>
                            <input type="text" value={salePricePercent} onChange={event => this.setState({ salePricePercent: event.target.value })} placeholder="Введите комиссию (опт)" />

                            <p>Описание</p>
                            <textarea value={description} onChange={event => this.setState({ description: event.target.value })} placeholder="Введите описание"></textarea>
                        </div>
                    </div>

                    <div className="content-form-bottom">
                        <div onClick={() => this.create()} className="content-form-button">Сохранить</div>
                    </div>

                </div>

            </div>
        )
    }

}

export default withRouter(EditProduct)